'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { LINK_PRIVACY } from '@constants/page-links';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <p>
          We use cookies to improve your experience, analyse traffic, and personalise content. 
          Read our{' '}
          <Link href={LINK_PRIVACY}>Privacy Policy</Link>.
        </p>

        <div className="cookie-actions">
          <button className="btn reject" onClick={rejectCookies}>
            Reject
          </button>
          <button className="btn accept" onClick={acceptCookies}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}